module.exports = __webpack_public_path__ + "static/about01-4b29b3f1d175d4e5a545561802de1e72.jpg";